import { FC } from 'react';
import { BasicImageTypes, NextgenImageProps } from './types/propsTypes';

const FallbackNextgenImage: FC<NextgenImageProps> = ({ src, alt, ...rest }: NextgenImageProps) => (
  <img src={src as string} alt={alt} {...(rest as BasicImageTypes)} />
);

export default FallbackNextgenImage;
